export default __webpack_public_path__ + "static/media/splash.56bc83ea.jpg";